const AvailabilityStatusValues = Object.freeze({

  NO_ROOM: {
    value: '0'
  },
  CNF: {
    value: '1'
  },
  RAC: {
    value: '2'
  },
  WL: {
    value: '3'
  },
  NT:{
    value: '4',
  },
  MSG:{
    value:'5',
  },
  DEPARTED: {
    value: '8224'
  },
});

export default AvailabilityStatusValues;
